export const makeDisplayName = <P extends object>(
  hocName: string,
  Component: React.ComponentType<P>,
) => {
  return `${hocName}(${
    Component.displayName || Component.name || 'MissingDisplayName'
  })`;
};
